// Toast notifications — replaces ui.js showToast. A global store + <Toaster/>
// (mounted at the app root so auth screens and the shell both reach it).
// Call toast(message, type) from anywhere.

import { create } from 'zustand'

export type ToastType = 'info' | 'success' | 'error' | 'warning'

interface Toast {
  id: number
  message: string
  type: ToastType
}

interface ToastState {
  toasts: Toast[]
  push: (message: string, type?: ToastType) => void
}

let nextId = 1

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],
  push: (message, type = 'info') => {
    const id = nextId++
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }))
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
    }, 3000)
  },
}))

export function toast(message: string, type: ToastType = 'info'): void {
  useToastStore.getState().push(message, type)
}
